import { render, staticRenderFns } from "./TemplateMappingWizardJobTemplateStep.vue?vue&type=template&id=6209406d&"
import script from "./TemplateMappingWizardJobTemplateStep.vue?vue&type=script&lang=ts&"
export * from "./TemplateMappingWizardJobTemplateStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDivider,VSelect})
